import snakeCase from 'lodash/snakeCase';

export const getActionType = (actionType, namespace, identifier) => identifier ?
  `@${namespace}/${actionType}_${snakeCase(identifier)}`.toUpperCase() :
  `@${namespace}/${actionType}`.toUpperCase();
